module.exports = __webpack_public_path__ + "img/Physician - Medium Gray.71c70235.png";